<template>
  <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
    <WineMobile  v-if="matches" />
    <WineDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import WineMobile from "./Wine_Mobile.vue";
  import WineDesktop from "./Wine_Desktop.vue";
 
  export default {
    name: 'Wine',
    components: {
      MatchMedia,
      WineMobile,
      WineDesktop,
    },
  }
</script> 